export default __webpack_public_path__ + "static/CDR-Oct5-4c496e4af7b3d71880b2dd48cd572272.png";